import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./css/index.scss";
import "./i18n";
import { setupAxios } from "./setupAxios";

setupAxios();

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
